module.exports = __webpack_public_path__ + "media/images/favicn/favicon-a6da96ac800c5dcb3392dd7cd2565c44.ico";